module.exports = __webpack_public_path__ + "img/dmno.426e4f72.png";